import React from 'react'
import Nav2 from '../Nav2';
import './Park.css';
import{Input} from 'react-rainbow-components'
export const Park = () => {
  return (
    <>
       <div className='bg-s'>
           <div>
             <Nav2/>
           </div>
           <div className='b11'>
                <div>
                    <div className="flex inputs">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                    <div className="flex inputs2">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                    <div className="flex inputs3">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                    <div className="flex inputs4">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                </div>
                <div className='b2'>
                    <div className="flex inputs">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                    <div className="flex inputs2">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                    <div className="flex inputs3">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                    <div className="flex inputs4">
                        <div >
                            <b class="inp"> Current(A):</b>
                            <Input disabled className="disabled-cursor1  input"  />                      
                        </div>

                        <div>
                            <b class="inp"> Power(W):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                        <div >
                            <b class="inp">Energy(Kwh):</b>
                            <Input disabled className="disabled-cursor1 input " />
                        </div>
                    </div>
                </div>
           </div>
       </div>
    
    </>
  )
}
